import { MultiSelectItem } from "../types";

export interface TagProps<TItem extends MultiSelectItem> {
  item: TItem;
  selectedItems: TItem[];
}
export const Tag = <TItem extends MultiSelectItem>({ item, selectedItems }: TagProps<TItem>): string | null => {
  return selectedItems.length > 1 ? (item.id === selectedItems[0]?.id ? "Multiple Selections" : null) : item.label;
};
